(function () {
    'use strict';

    function documentConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'siteConfiguration/directives/templates/documentConfiguration.html',
            link: function (scope) {

            }
        };
    }

    documentConfiguration.$inject = [];

    angular.module('ecap.siteConfiguration').directive('documentConfiguration', documentConfiguration);
})();
